import { formatters } from '@nexelem/utils';
import { useFormContext, useWatch } from 'react-hook-form';
import { useCustomTranslation } from '../../../../../../hooks';
import { SingleDetail } from '../../../../../atoms/SingleDetail';
import { ProductionInWarehouseModalSchema } from '../KanbanInProgressToCompletedModal';

export type TotalProductionProps = {
  unit: string;
  currentProgress: number;
};

export const TotalProduction = ({ unit, currentProgress }: TotalProductionProps) => {
  const { control } = useFormContext<ProductionInWarehouseModalSchema>();
  const [oks, noks] = useWatch({ name: ['oks', 'noks'], control });

  const { tWrapper } = useCustomTranslation('products.productionPlan.kanban.modals.inputLabels');

  const total = (Number(oks) || 0) + (Number(noks) || 0) + (Number(currentProgress) || 0);

  return <SingleDetail content={formatters.number.format(total)} title={tWrapper('totalMade', { unit })} />;
};
